import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelBCandidateListResponse, LevelBReportFilter } from "../../types/levelb-reports";

interface UseGetLevelBCandidatesParams {
  filter: LevelBReportFilter;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

export const useGetLevelBCandidates = ({
  filter,
  search,
  sortBy = 'examDate',
  sortOrder = 'desc',
  page = 1,
  pageSize = 25,
  enabled = true,
}: UseGetLevelBCandidatesParams) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const fetchCandidates = async (): Promise<LevelBCandidateListResponse> => {
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
        sortBy,
        sortOrder,
        page: page.toString(),
        pageSize: pageSize.toString(),
      });

      if (filter.examTermId) {
        params.append('examTermId', filter.examTermId);
      }
      if (filter.examId) {
        params.append('examId', filter.examId);
      }
      if (search) {
        params.append('search', search);
      }

      const { data } = await axios.get(`/api/levelbreports/candidates?${params.toString()}`);
      return data;
    } catch (error) {
      throw new Error(t("levelBReports.errors.getCandidates"));
    }
  };

  return useQuery({
    queryKey: ["levelBCandidates", filter, search, sortBy, sortOrder, page, pageSize],
    queryFn: fetchCandidates,
    enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate),
  });
};

